import { useRef } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { t } from '@/utils/i18n';

export const useModalState = () => {
  const navigate = useNavigate();
  const isActive = Boolean(useMatch('/upload'));

  const title = t('uploadPanel.uploadImage');

  const onClose = () => navigate('/');

  const legalRef = useRef(false);
  const uploadsRef = useRef([]);
  const scrollStartIndex = useRef(0);

  return [title, isActive, onClose, legalRef, uploadsRef, scrollStartIndex] as const;
};
